module.exports = __webpack_public_path__ + "static/img/brand-third-1.cbd11498.png";